module.exports = __webpack_public_path__ + "static/media/feature_risk_management.45c774e7.png";